import React, { useEffect, useState } from 'react';
import { getResultsData } from "../utils/helper";

const Results = ({ isExpired }) => {
    const [resultsData, setResultsData] = useState(null);
    const [activeTab] = useState('daily');

    useEffect(() => {
        getResultsData().then(data => {
            if(data && data.daily && Object.keys(data.daily).length) {
                setResultsData(data)
            }
        });
    }, []);

    return (
        <main className="results-main">
            <div className="flex">
                <div className="flex flex-col justify-center align-center mx-auto">
                    <div className="results-content pt-6 pb-8 xl:py-20 text-center">
                        <div className="mb-8">
                            <div className="container-sm">
                                <h1 className="results-heading px-8 md:px-0">Is your name on Santa’s “good” list?</h1>
                            </div>
                            <div className="results-intro container-xs">
                                {isExpired ? (
                                    <p>Thanks for sleighing through the MyALDI Advent Calendar!
                                        From ham slinging and merry matching to frenzied fruit slicing and pana whacking,
                                        we hope you had lots of festive fun! Congratulations to all our winners, and we'll see you next year!

                                    </p>
                                ) : (
                                    <>
                                        <p className="mb-5 mt-8"> See if you’re today’s prize winner!</p>
                                        <p>Individual prizes are $100 and $50 DoorDash vouchers for winners and runners-up. If your name is shining bright on the list,
                                            email  <a className='underline' href='mailto:internal.comms@aldi.com.au'>internal.comms@aldi.com.au</a> and confirm your full name and Employee ID to claim your prize.</p>
                                    </>

                                )}
                            </div>
                        </div>

                        {/* Tab buttons */}
                        {/* <div className="flex justify-center mb-6 space-x-4 px-4">
                            <button onClick={() => setActiveTab('daily')} className="btn btn-header">
                                <span className={`md:min-h-[52px] py-[21px] pt-[12px] ${activeTab !== 'daily' ? 'unselected-btn-span' : ''}`}>
                                    Daily Prize Winners
                                </span>
                            </button>
                            <button onClick={() => setActiveTab('weekly')} className="btn btn-header">
                                <span className={`md:min-h-[52px] py-[21px] pt-[12px] ${activeTab !== 'weekly' ? 'unselected-btn-span' : ''}`}>
                                    Weekly Team Champions
                                </span>
                            </button>
                        </div> */}

                        <div className="container-sm 2xl:max-w-[540px] result-block">
                            {/* Daily results */}
                            {activeTab === 'daily' && resultsData && resultsData.daily && Object.keys(resultsData.daily).length > 0 && (
                                <ul>
                                    {Object.keys(resultsData.daily).sort((a, b) => Number(b) - Number(a)).map((i) => {
                                        return (
                                            <li key={i}>
                                                <div className='!bg-background-initial !bg-no-repeat !bg-cover'>
                                                    <h3 className='result-day-heading'>{`Day ${i}`}</h3>
                                                    <p className='result-details'> Winner: <strong>{resultsData.daily[i].winner}</strong></p>
                                                    <p className='result-details'> Runner up: <strong>{resultsData.daily[i].runner_up}</strong></p>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            )}

                            {/* Daily results - no data message */}
                            {(activeTab === 'daily' && (!resultsData || !resultsData.daily || Object.keys(resultsData.daily).length === 0)) && (
                                <ul>
                                    <li className="message">
                                         <div className='!bg-background-initial !bg-no-repeat !bg-cover result-message'>
                                            <p>
                                                On your marks, get set, GO! Check back here tomorrow for the winners of the first Advent&nbsp;Calendar&nbsp;game
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            )}

                            {/* Weekly results */}
                            {/* {activeTab === 'weekly' && resultsData && resultsData.weekly && Object.keys(resultsData.weekly).length > 0 && (
                                <ul>
                                    {Object.keys(resultsData.weekly).sort((a, b) => Number(b) - Number(a)).map((i) => {
                                        return (
                                            <li key={i}>
                                                <div className='!bg-background-initial !bg-no-repeat !bg-cover'>
                                                    <h3 className='result-day-heading'>{`Week ${i} Champs`}</h3>
                                                    <p className='result-details'> Store: <strong>{resultsData.weekly[i].store}</strong></p>
                                                    <p className='result-details'> Distribution Centre: <strong>{resultsData.weekly[i].distribution_centre}</strong></p>
                                                    <p className='result-details'> National Office: <strong>{resultsData.weekly[i].national_office}</strong></p>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            )} */}

                            {/* Weekly results - no data message */}
                            {/* {(activeTab === 'weekly' && (!resultsData || !resultsData.weekly || Object.keys(resultsData.weekly).length === 0)) && (
                                <ul>
                                    <li className="message">
                                        <div className='!bg-background-initial !bg-no-repeat !bg-cover result-message'>
                                            <p>
                                                Weekly champions will be announced soon. Check&nbsp;back&nbsp;later!
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            )} */}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Results;
